/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CompanyFromJSON(json) {
    return CompanyFromJSONTyped(json, false);
}
export function CompanyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'companyCode': !exists(json, 'companyCode') ? undefined : json['companyCode'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'vendorType': !exists(json, 'vendorType') ? undefined : json['vendorType'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
export function CompanyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'companyId': value.companyId,
        'propertyId': value.propertyId,
        'companyCode': value.companyCode,
        'companyName': value.companyName,
        'vendorType': value.vendorType,
        'phone': value.phone,
    };
}
